// 환자 웹(/p/) 공용 껍데기 — 상단 브랜드, 본문, 하단 고정 문구 + SiteFooter
// blocked=true: 치과·기공소 계정으로 로그인된 브라우저 → 진행 차단 안내만 (실사 §3 권고: 별도 Auth 인스턴스 대신 안내)
// open=false: 플래그 OFF(비로그인 공개 경로) → 준비 중 안내
import React from 'react';
import SiteFooter from '../common/SiteFooter';
import { BUSINESS_BLOCKED, PATIENT_FOOT_NOTE } from '../../config/patientConsent';
import { P } from './patientStyles';

function PatientShell({ children, blocked = false, open = true, right = null }) {
    return (
        <div style={P.page}>
            <div style={P.header}>
                <span style={P.brand}>덴클 환자 안내</span>
                {right}
            </div>
            <div style={P.body}>
                {blocked ? (
                    <div style={P.card}>
                        <h2 style={P.h2}>환자 본인 휴대폰으로 진행해 주세요</h2>
                        <p style={P.text}>{BUSINESS_BLOCKED}</p>
                    </div>
                ) : !open ? (
                    <div style={P.card}>
                        <h2 style={P.h2}>준비 중입니다</h2>
                        <p style={P.text}>환자 등록 기능은 아직 열리지 않았습니다. 치과 데스크에 문의해 주세요.</p>
                    </div>
                ) : children}
            </div>
            <div style={P.footNote}>{PATIENT_FOOT_NOTE}</div>
            <SiteFooter />
        </div>
    );
}

export default PatientShell;
